import React from 'react'

import "./Hero.css"
import { MotionProps, motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const Hero = () => {
  const navigate = useNavigate();
    const getFadeUpAnimation = (index = 0): MotionProps => ({
    initial: { opacity: 0, y: 30 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: "0px" },
    transition: {
        duration: 0.5,
        ease: "easeOut",
        delay: index * 0.3,
    },
    });

  return (
    <div className='hero-section'>
        <div className='hero-content'>
          <h1>EL NUEVO ESTÁNDAR EN PROTECCIÓN TCG.</h1>
          <span>Ingeniería de precisión y materiales de nivel archivo para defender tus cartas más valiosas. Diseñado para coleccionistas que no aceptan un "suficientemente bueno".</span>
        
          <div>
            <button className='button-card-armory' onClick={()=>{navigate("/galeria")}} >Explorar Colección</button>
          </div>
        </div>

        <motion.div className='hero-binder' {...getFadeUpAnimation(1)} >
          <img src="/images/binder-morado.png" />
        </motion.div>

        <motion.div className='hero-deckbox' {...getFadeUpAnimation(2)}>
          <img src="/images/deck-box-open.png" />
        </motion.div>

        <motion.div className='hero-sleeves' {...getFadeUpAnimation(3)} >
          <img src="/images/magnetico.png" />
        </motion.div>


    </div>
  )
}

export default Hero